import Logger from '@/utils/Logger';
import { TencentBrowserEventTracker } from '@sasan/event-tracker';
import isIpePlatform from './isIpePlatform';

function getTopicId() {
  const isProduction = process.env.MODE === 'production';

  if (isIpePlatform()) {
    return isProduction
      ? 'ipe-courseware-events-production-1317286674'
      : 'ipe-courseware-events-staging-1317286674';
  }
  return isProduction
    ? 'courseware-events-production-1317286674'
    : 'courseware-events-staging-1317286674';
}

const EventTracker = new TencentBrowserEventTracker({
  projectId: 'sasan-courseware',
  topicId: getTopicId(),
  endpoint: 'https://ap-beijing.cls.tencentcs.com',
  logger: Logger,
  debug: process.env.EVENT_TRACKER_DEBUG === 'true',
});

export default EventTracker;
